export default "__VITE_ASSET__DJYGUX8A__"